import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'awsDateTransform'
})
export class DateTransformToAWSTPipe implements PipeTransform {
  transform(value: string | Date, format: string = 'dd/MM/yyyy HH:mm:ss'): string {

    if (!value) return '';

    const iso = typeof value === 'string' && !value.includes('Z') ? value + 'Z' : value;

    const utcDate = new Date(iso);


    const dateFormatter = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Perth',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });

    const timeFormatter = new Intl.DateTimeFormat('en-AU', {
      timeZone: 'Australia/Perth',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

    const formattedDate = dateFormatter.format(utcDate);
    const formattedTime = timeFormatter.format(utcDate);

    return `${formattedDate} ${formattedTime}`;
  }
}
